/* eslint-disable no-unused-vars */
// needed since color isn't used in the template but appears in the replaced body
import React from "react";
import PropTypes from "prop-types";

/*
 * Yuka v2.0
 * This component corresponds to ``link.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */
const LinkIcon = ({ color, size }) => (
  <svg width={size} height={size} viewBox="0 0 18 18">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        fill={color}
        fillRule="evenodd"
        d="M9.58149 2.06301C10.4302 1.2433 11.5669 0.789722 12.7468 0.799975C13.9267 0.810228 15.0553 1.28349 15.8897 2.11782C16.724 2.95216 17.1973 4.08082 17.2075 5.2607C17.2178 6.44059 16.7642 7.5773 15.9445 8.42601L15.9354 8.4353L13.6855 10.6852C13.6854 10.6852 13.6855 10.6852 13.6855 10.6852C13.2293 11.1415 12.6802 11.4945 12.0757 11.72C11.4711 11.9455 10.8251 12.0384 10.1814 11.9923C9.53781 11.9462 8.91162 11.7622 8.34535 11.4529C7.77908 11.1435 7.28596 10.7159 6.89946 10.1992C6.65135 9.86752 6.71911 9.39751 7.05079 9.1494C7.38248 8.9013 7.8525 8.96905 8.1006 9.30074C8.35827 9.64522 8.68702 9.93025 9.06453 10.1365C9.44205 10.3428 9.85951 10.4654 10.2886 10.4961C10.7177 10.5269 11.1484 10.465 11.5514 10.3146C11.9545 10.1643 12.3205 9.92898 12.6246 9.62474L14.8699 7.37948C15.4136 6.81415 15.7144 6.05826 15.7076 5.27374C15.7008 4.48715 15.3852 3.73471 14.829 3.17848C14.2728 2.62226 13.5204 2.30675 12.7338 2.29992C11.9489 2.2931 11.1927 2.59416 10.6272 3.13839L9.34131 4.41685C9.04756 4.70889 8.57269 4.7075 8.28065 4.41376C7.98862 4.12001 7.99 3.64514 8.28375 3.3531L9.57375 2.0706L9.58149 2.06301ZM5.92439 6.27994C6.52897 6.05441 7.17499 5.96154 7.81862 6.00764C8.46224 6.05374 9.08843 6.23771 9.65471 6.54709C10.221 6.85648 10.7141 7.28402 11.1006 7.80074C11.3487 8.13243 11.281 8.60244 10.9493 8.85055C10.6176 9.09865 10.1476 9.0309 9.89945 8.69921C9.64178 8.35473 9.31304 8.0697 8.93552 7.86344C8.55801 7.65719 8.14055 7.53454 7.71146 7.50381C7.28238 7.47308 6.8517 7.53499 6.44865 7.68534C6.04559 7.83569 5.67959 8.07097 5.37545 8.37521L3.13022 10.6204C2.58644 11.1858 2.28565 11.9417 2.29247 12.7262C2.29931 13.5128 2.61481 14.2652 3.17104 14.8215C3.72726 15.3777 4.4797 15.6932 5.26629 15.7C6.05083 15.7068 6.80674 15.4061 7.37207 14.8623L8.6497 13.5846C8.94259 13.2917 9.41746 13.2917 9.71036 13.5846C10.0033 13.8775 10.0033 14.3524 9.71036 14.6453L8.42786 15.9278L8.41856 15.9369C7.56985 16.7567 6.43314 17.2102 5.25326 17.2C4.07337 17.1897 2.94471 16.7165 2.11038 15.8821C1.27604 15.0478 0.802781 13.9191 0.792529 12.7392C0.782276 11.5594 1.23585 10.4227 2.05556 9.57394L2.0647 9.56464L4.3146 7.31474C4.31463 7.31471 4.31457 7.31477 4.3146 7.31474C4.77078 6.85842 5.31985 6.50545 5.92439 6.27994Z"
        transform=""
      />
    </g>
  </svg>
);

LinkIcon.propTypes = {
  // all of these can be overriden in CSS as necessary
  color: PropTypes.string,
  size: PropTypes.number,
};

LinkIcon.defaultProps = {
  color: "#ffffff",
  size: 16,
};

LinkIcon.displayName = "LinkIcon";

export default LinkIcon;
